import { Component, OnInit, Input, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';

export enum BARCOLOR {
  red,
  blue,
  green
}

interface Bar {
  value:  number,
  color:  BARCOLOR,
  text?:  string,
  left?: string,
  right?: string,
  group?: Bar
}

interface DiagramData {
  title?: string,
  bars: Array<Bar>
}

interface DiagramBars {
  imgs : {
    head: string,
    body2?: string,
    foot2?: string,
    body: string,
    foot: string
  },
  color: string,
  height: number,
  value: number,
  text?: string,
  left?: string,
  right?: string,
  groupLeft?: string,
  groupRight?: string,
  group: number,
  groupColor?: string;
}

export interface DiagramDatas {
  height: number,
  diagrams: Array<DiagramData>
}

@Component({
  selector: 'app-diagram',
  templateUrl: './diagram.component.html',
  styleUrls: ['./diagram.component.css']
})

export class DiagramComponent {

  @Input() diagramDatas: DiagramDatas;

  diagrams: Array<{
    title: string,
    bars : Array<DiagramBars>
  }> = [];
  
  constructor() {}

  ngOnChanges() {
    let max       : number        = 0;
    let maxArr    : Array<number> = [];
    let barCount  : number        = 0;
    
    this.diagramDatas.diagrams.forEach( diagram => {
      barCount += diagram.bars.length;
      maxArr.push(Math.max(...diagram.bars.map(o => {
          if(o.group){
            return o.value + o.group.value; 
          } else {
            return o.value;  
          }        
        })
      ));
    });
    
    max = Math.max(...maxArr);
  
    this.diagramDatas.diagrams.forEach( (diagram, idx) => {
      
      this.diagrams[idx] = {
        title :  diagram.title,
        bars : []
      }

      diagram.bars.forEach( bar => {
        let imgs;
        let height = this.diagramDatas.height;
        let value = bar.value;
        
        if(bar.group){
          value += bar.group.value;
        }

        if(value < max){
          height = (this.diagramDatas.height/max)*value;
        }

        imgs = this.getImagePaths(bar.color)
        
        if( bar.group ){
          let tmp = this.getImagePaths(bar.group.color, true);
          imgs.head = tmp.head;
          imgs.body2 = tmp.body;   
          imgs.foot2 = tmp.foot;    
          imgs.groupColor = tmp.groupColor;      
        }

        this.diagrams[idx].bars.push({
          imgs: {
            head: imgs.head,
            body2: imgs.body2,
            foot2: imgs.foot2,
            body: imgs.body,
            foot: imgs.foot
          },
          color:  imgs.color,
          height: height,
          value:  value,
          text:   bar.text,
          left:   bar.left,
          right:  bar.right,
          group:  0
        });
        
        if(bar.group) {
          this.diagrams[idx].bars[this.diagrams[idx].bars.length -1].group = bar.group.value;
          this.diagrams[idx].bars[this.diagrams[idx].bars.length -1].groupLeft = bar.group.left;
          this.diagrams[idx].bars[this.diagrams[idx].bars.length -1].groupRight = bar.group.right;
          this.diagrams[idx].bars[this.diagrams[idx].bars.length -1].groupColor = imgs.groupColor;
        }         
      });
    
    });
  
  }
  
  getImagePaths(color, group?){
    let imgs = {
      head:   "",
      body2:  undefined,
      foot2:  undefined,
      body:   "",
      foot:   "",
      color: "",
      groupColor: undefined
    };
    
    switch (color) {
      case BARCOLOR.red:
        imgs.head  = "assets/img/diagram/redHead.png";
        imgs.body  = "assets/img/diagram/redBody.png";
        
        imgs.color = "#C61120";
        
        if(group){
          imgs.foot  = "assets/img/diagram/redFootNoShadow.png";
          imgs.groupColor = "#C61120"
        } else {
          imgs.foot  = "assets/img/diagram/redFoot.png";
        }

        break;
      case BARCOLOR.blue:
        imgs.head  = "assets/img/diagram/blueHead.png";
        imgs.body  = "assets/img/diagram/blueBody.png";
        
        imgs.color = "#1094BF";

        if(group){
          imgs.foot  = "assets/img/diagram/blueFootNoShadow.png";
          imgs.groupColor = "#1094BF"
        } else {
          imgs.foot  = "assets/img/diagram/blueFoot.png";
        }
        
        break;
      case BARCOLOR.green:
        imgs.head  = "assets/img/diagram/greenHead.png";
        imgs.body  = "assets/img/diagram/greenBody.png";
        
        imgs.color = "#23984E";
        
        if(group){
          imgs.foot  = "assets/img/diagram/greenFootNoShadow.png";
          imgs.groupColor = "#23984E"
        } else {
          imgs.foot  = "assets/img/diagram/greenFoot.png";
        }
        
        break;
      default:
        break;
    }  
    
    return imgs;
  }

  calcHeight(bar){
    if (bar.group){
      return ( (bar.height-30) / bar.value ) * bar.group;
    } else {
      return 0;
    }    
  }    
  
}


// WEBPACK FOOTER //
// ./src/app/diagram/diagram.component.ts